/**
 * @generated SignedSource<<351ddbe836f36f66f6adbe92776f5fa8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type videoShortCarouselPlayerContent$data = {
  readonly entityId?: string;
  readonly headline?: string | null | undefined;
  readonly youtubeId?: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"actionWidgetContent" | "entityLink" | "shareArticle20Content">;
  readonly " $fragmentType": "videoShortCarouselPlayerContent";
};
export type videoShortCarouselPlayerContent$key = {
  readonly " $data"?: videoShortCarouselPlayerContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"videoShortCarouselPlayerContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "videoShortCarouselPlayerContent",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headline",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "youtubeId",
          "storageKey": null
        }
      ],
      "type": "Video",
      "abstractKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "actionWidgetContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "shareArticle20Content"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "cc25744ed5fb129db3936a860a8779de";

export default node;
